import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="py-20 md:py-32 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-12 md:mb-16 rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20concept%20with%20floating%20newspaper%20headlines%20and%20digital%20screens%2C%20warm%20orange%20and%20crimson%20gradient%20background%2C%20modern%20media%20aesthetic%2C%20bold%20composition%2C%20newsroom%20energy%2C%20grainy%20texture%2C%20cinematic%20photography&width=1200&height=600&seq=cta-banner&orientation=landscape"
            alt="吃瓜爆料投稿"
            className="w-full object-cover"
          />
        </div>

        <p className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-relaxed tracking-tight max-w-3xl mx-auto">
          有<span className="italic text-foreground-400 font-light">猛料</span>想爆料？
          <br />
          吃瓜网<span className="font-black">等你来投稿</span>
          <br />
          一起做<span className="italic text-foreground-400 font-light">最前线</span>的吃瓜群众
        </p>

        <Link
          to="/about"
          className="mt-10 md:mt-14 inline-flex items-center gap-2 px-10 py-4 bg-foreground-950 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap text-sm"
        >
          联系我们投稿
          <i className="ri-send-plane-line"></i>
        </Link>
      </div>
    </section>
  );
}